// @ts-nocheck
import {Column} from 'react-table'
import {UserInfoCell} from './UserInfoCell'
import {UserActionsCell} from './UserActionsCell'
import {UserSelectionCell} from './UserSelectionCell'
import {UserCustomHeader} from './UserCustomHeader'
import {UserSelectionHeader} from './UserSelectionHeader'
import {UserJoinedDate} from './UserJoinedCell'
import {LinksData, User} from '../../core/_models'
import { ScrappingStatuCell ,EmbeddingStatusCell} from './UserStatusCell'

const usersColumns: ReadonlyArray<Column<LinksData>> = [
  
  {
    Header: (props) => <UserSelectionHeader tableProps={props} />,
    id: 'selection',
    Cell: ({...props}) => <UserSelectionCell id={props.data[props.row.index]._id} />,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Link' className='min-w-125px' />,
    id: 'link',
    Cell: ({...props}) => <UserInfoCell embeddings={props.data[props.row.index]} />,
  },
  
  
 

  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Characters' className='min-w-125px' />
    ),
    id: 'characters',
    Cell: ({...props}) => <UserJoinedDate embeddings={props.data[props.row.index]} />,
  },
  
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Status' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({...props}) => <ScrappingStatuCell linksData={props.data[props.row.index]} 
    />,
  },
]

export {usersColumns}
